/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../model';
// @ts-ignore
import { GetRpaResponse } from '../model';
// @ts-ignore
import { GetRpasResponse } from '../model';
// @ts-ignore
import { PostRPARequest } from '../model';
// @ts-ignore
import { PostRpaResponse } from '../model';
// @ts-ignore
import { PutRPARequest } from '../model';
// @ts-ignore
import { PutRpaResponse } from '../model';
/**
 * RpasApi - axios parameter creator
 * @export
 */
export const RpasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueRPA: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('continueRPA', 'id', id)
            const localVarPath = `/api/rpas/{id}/treatmentReq/continue`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRPA: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRPA', 'id', id)
            const localVarPath = `/api/rpas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutRPARequest} putRPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRPA: async (id: string, putRPARequest: PutRPARequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editRPA', 'id', id)
            // verify required parameter 'putRPARequest' is not null or undefined
            assertParamExists('editRPA', 'putRPARequest', putRPARequest)
            const localVarPath = `/api/rpas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putRPARequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRPA: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRPA', 'id', id)
            const localVarPath = `/api/rpas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRpaByUnit: async (unitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('getRpaByUnit', 'unitId', unitId)
            const localVarPath = `/api/rpas/{unitId}/getRpaByUnit`
                .replace(`{${"unitId"}}`, encodeURIComponent(String(unitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} [keyword] 
         * @param {string} [customer] 
         * @param {string} [location] 
         * @param {string} [unit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRpas: async (orderBy: string, orderDesc: string, limit: number, page: number, keyword?: string, customer?: string, location?: string, unit?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('getRpas', 'orderBy', orderBy)
            // verify required parameter 'orderDesc' is not null or undefined
            assertParamExists('getRpas', 'orderDesc', orderDesc)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getRpas', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getRpas', 'page', page)
            const localVarPath = `/api/rpas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (customer !== undefined) {
                localVarQueryParameter['customer'] = customer;
            }

            if (location !== undefined) {
                localVarQueryParameter['location'] = location;
            }

            if (unit !== undefined) {
                localVarQueryParameter['unit'] = unit;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostRPARequest} postRPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRPA: async (postRPARequest: PostRPARequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postRPARequest' is not null or undefined
            assertParamExists('postRPA', 'postRPARequest', postRPARequest)
            const localVarPath = `/api/rpas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRPARequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recountRPA: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('recountRPA', 'id', id)
            const localVarPath = `/api/rpas/{id}/treatmentReq/recount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RpasApi - functional programming interface
 * @export
 */
export const RpasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RpasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async continueRPA(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.continueRPA(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRPA(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRPA(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutRPARequest} putRPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editRPA(id: string, putRPARequest: PutRPARequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutRpaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editRPA(id, putRPARequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRPA(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRpasResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRPA(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRpaByUnit(unitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRpaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRpaByUnit(unitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} [keyword] 
         * @param {string} [customer] 
         * @param {string} [location] 
         * @param {string} [unit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRpas(orderBy: string, orderDesc: string, limit: number, page: number, keyword?: string, customer?: string, location?: string, unit?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRpasResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRpas(orderBy, orderDesc, limit, page, keyword, customer, location, unit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostRPARequest} postRPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRPA(postRPARequest: PostRPARequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostRpaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRPA(postRPARequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recountRPA(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recountRPA(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RpasApi - factory interface
 * @export
 */
export const RpasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RpasApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueRPA(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.continueRPA(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRPA(id: string, options?: any): AxiosPromise<BaseResponse> {
            return localVarFp.deleteRPA(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutRPARequest} putRPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editRPA(id: string, putRPARequest: PutRPARequest, options?: any): AxiosPromise<PutRpaResponse> {
            return localVarFp.editRPA(id, putRPARequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRPA(id: string, options?: any): AxiosPromise<GetRpasResponse> {
            return localVarFp.getRPA(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRpaByUnit(unitId: string, options?: any): AxiosPromise<GetRpaResponse> {
            return localVarFp.getRpaByUnit(unitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderBy 
         * @param {string} orderDesc 
         * @param {number} limit 
         * @param {number} page 
         * @param {string} [keyword] 
         * @param {string} [customer] 
         * @param {string} [location] 
         * @param {string} [unit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRpas(orderBy: string, orderDesc: string, limit: number, page: number, keyword?: string, customer?: string, location?: string, unit?: string, options?: any): AxiosPromise<GetRpasResponse> {
            return localVarFp.getRpas(orderBy, orderDesc, limit, page, keyword, customer, location, unit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostRPARequest} postRPARequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRPA(postRPARequest: PostRPARequest, options?: any): AxiosPromise<PostRpaResponse> {
            return localVarFp.postRPA(postRPARequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recountRPA(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.recountRPA(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for continueRPA operation in RpasApi.
 * @export
 * @interface RpasApiContinueRPARequest
 */
export interface RpasApiContinueRPARequest {
    /**
     * 
     * @type {string}
     * @memberof RpasApiContinueRPA
     */
    readonly id: string
}

/**
 * Request parameters for deleteRPA operation in RpasApi.
 * @export
 * @interface RpasApiDeleteRPARequest
 */
export interface RpasApiDeleteRPARequest {
    /**
     * 
     * @type {string}
     * @memberof RpasApiDeleteRPA
     */
    readonly id: string
}

/**
 * Request parameters for editRPA operation in RpasApi.
 * @export
 * @interface RpasApiEditRPARequest
 */
export interface RpasApiEditRPARequest {
    /**
     * 
     * @type {string}
     * @memberof RpasApiEditRPA
     */
    readonly id: string

    /**
     * 
     * @type {PutRPARequest}
     * @memberof RpasApiEditRPA
     */
    readonly putRPARequest: PutRPARequest
}

/**
 * Request parameters for getRPA operation in RpasApi.
 * @export
 * @interface RpasApiGetRPARequest
 */
export interface RpasApiGetRPARequest {
    /**
     * 
     * @type {string}
     * @memberof RpasApiGetRPA
     */
    readonly id: string
}

/**
 * Request parameters for getRpaByUnit operation in RpasApi.
 * @export
 * @interface RpasApiGetRpaByUnitRequest
 */
export interface RpasApiGetRpaByUnitRequest {
    /**
     * 
     * @type {string}
     * @memberof RpasApiGetRpaByUnit
     */
    readonly unitId: string
}

/**
 * Request parameters for getRpas operation in RpasApi.
 * @export
 * @interface RpasApiGetRpasRequest
 */
export interface RpasApiGetRpasRequest {
    /**
     * 
     * @type {string}
     * @memberof RpasApiGetRpas
     */
    readonly orderBy: string

    /**
     * 
     * @type {string}
     * @memberof RpasApiGetRpas
     */
    readonly orderDesc: string

    /**
     * 
     * @type {number}
     * @memberof RpasApiGetRpas
     */
    readonly limit: number

    /**
     * 
     * @type {number}
     * @memberof RpasApiGetRpas
     */
    readonly page: number

    /**
     * 
     * @type {string}
     * @memberof RpasApiGetRpas
     */
    readonly keyword?: string

    /**
     * 
     * @type {string}
     * @memberof RpasApiGetRpas
     */
    readonly customer?: string

    /**
     * 
     * @type {string}
     * @memberof RpasApiGetRpas
     */
    readonly location?: string

    /**
     * 
     * @type {string}
     * @memberof RpasApiGetRpas
     */
    readonly unit?: string
}

/**
 * Request parameters for postRPA operation in RpasApi.
 * @export
 * @interface RpasApiPostRPARequest
 */
export interface RpasApiPostRPARequest {
    /**
     * 
     * @type {PostRPARequest}
     * @memberof RpasApiPostRPA
     */
    readonly postRPARequest: PostRPARequest
}

/**
 * Request parameters for recountRPA operation in RpasApi.
 * @export
 * @interface RpasApiRecountRPARequest
 */
export interface RpasApiRecountRPARequest {
    /**
     * 
     * @type {string}
     * @memberof RpasApiRecountRPA
     */
    readonly id: string
}

/**
 * RpasApi - object-oriented interface
 * @export
 * @class RpasApi
 * @extends {BaseAPI}
 */
export class RpasApi extends BaseAPI {
    /**
     * 
     * @param {RpasApiContinueRPARequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RpasApi
     */
    public continueRPA(requestParameters: RpasApiContinueRPARequest, options?: AxiosRequestConfig) {
        return RpasApiFp(this.configuration).continueRPA(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RpasApiDeleteRPARequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RpasApi
     */
    public deleteRPA(requestParameters: RpasApiDeleteRPARequest, options?: AxiosRequestConfig) {
        return RpasApiFp(this.configuration).deleteRPA(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RpasApiEditRPARequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RpasApi
     */
    public editRPA(requestParameters: RpasApiEditRPARequest, options?: AxiosRequestConfig) {
        return RpasApiFp(this.configuration).editRPA(requestParameters.id, requestParameters.putRPARequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RpasApiGetRPARequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RpasApi
     */
    public getRPA(requestParameters: RpasApiGetRPARequest, options?: AxiosRequestConfig) {
        return RpasApiFp(this.configuration).getRPA(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RpasApiGetRpaByUnitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RpasApi
     */
    public getRpaByUnit(requestParameters: RpasApiGetRpaByUnitRequest, options?: AxiosRequestConfig) {
        return RpasApiFp(this.configuration).getRpaByUnit(requestParameters.unitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RpasApiGetRpasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RpasApi
     */
    public getRpas(requestParameters: RpasApiGetRpasRequest, options?: AxiosRequestConfig) {
        return RpasApiFp(this.configuration).getRpas(requestParameters.orderBy, requestParameters.orderDesc, requestParameters.limit, requestParameters.page, requestParameters.keyword, requestParameters.customer, requestParameters.location, requestParameters.unit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RpasApiPostRPARequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RpasApi
     */
    public postRPA(requestParameters: RpasApiPostRPARequest, options?: AxiosRequestConfig) {
        return RpasApiFp(this.configuration).postRPA(requestParameters.postRPARequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RpasApiRecountRPARequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RpasApi
     */
    public recountRPA(requestParameters: RpasApiRecountRPARequest, options?: AxiosRequestConfig) {
        return RpasApiFp(this.configuration).recountRPA(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
